"use strict";
import io from "@eab-pip/pi-io";
import { stcCSRFInterceptor, stcFormCSRFInterceptor } from "./interceptors/csrf_interceptor";
export const stcCSRFIO = io.create("api", "api/stc").include("api/hosting").intercept(stcCSRFInterceptor).options({
  authorization: {
    type: "csrf"
  },
  settings: {
    handle_errors: "catch"
  }
}).intercept(io.fn.api.request.ctm).intercept(io.fn.api.response.noContent).intercept(io.fn.api.response.exposeRedirect).intercept(io.fn.api.response.humanReadableErrors);
export const stcFormIO = io.create("form", "api/stc/form").include("api/hosting").intercept(stcFormCSRFInterceptor).options({
  settings: {
    handle_errors: "catch"
  }
});
